import React from "react";
import { AlertTriangleIcon } from "../../../../../shared/svg/alertTriangle";
import { RedFlagIcon } from "../../../../../shared/svg/redFlag";

interface StringWithIconCellProps {
  value: {
    text: string;
    shouldShowBlockedIcon?: boolean;
    shouldShowAlertIcon?: boolean;
    textWidth?: string;
  };
  [key: string]: unknown;
}

/**
 * CPT Description column: truncated text with optional alert (non-preferred drug)
 * and red-flag (NCCN / config) icons, matching the layout before the postgres migration.
 */
export const StringWithIconCell: React.FC<StringWithIconCellProps> = ({
  value,
}) => {
  return (
    <>
      <div className="table-cell-multiline-text w-full">
        <div className="flex items-center gap-3">
          <div
            title={value.text}
            className="truncate"
            style={{
              maxWidth: value.textWidth,
              flexShrink: 0,
            }}
          >
            {value.text}
          </div>
          {value.shouldShowAlertIcon && <AlertTriangleIcon />}
          {value.shouldShowBlockedIcon && (
            <RedFlagIcon height={14} width={9.8} />
          )}
        </div>
      </div>
    </>
  );
};

export default StringWithIconCell;
